module.exports = require("react-dev-utils/noopServiceWorkerMiddleware");